<template>
    <div class="fx-v-center">
        <span class="before-date-picker">日期选择：</span>
        <el-date-picker
            v-bind="$attrs"
            v-on="$listeners"
            v-model="datePickerValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="clearable"
            :class="{ 'is-clearable': clearable }">
        </el-date-picker>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        clearable: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        datePickerValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.before-date-picker {
    font-size: 14px;
    color: #333;
}

::v-deep .el-date-editor {
    display: inline-flex;
    align-items: center;
    width: 236px !important;
    height: 36px;
    margin-right: 12px;
    line-height: 1;

    &.is-clearable {
        width: 252px !important;

        .el-range__close-icon {
            display: inline-block;
        }
    }

    > * {
        height: auto;
    }

    .el-range-input,
    .el-range-separator {
        font-size: 14px;
    }

    .el-range-separator {
        width: 20px;
        padding: 0;
        margin: 0 !important;
        transform: translateY(-1px);
        font-size: 14px;
    }

    .el-range-input::placeholder {
        color: #999;
    }

    .el-range__close-icon {
        display: none;
    }

    .el-input__icon::before {
        font-size: 16px;
    }
}
</style>